import script from "./CatalogCategorySelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogCategorySelection.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogCategorySelection.vue?vue&type=style&index=0&id=19a8e0bb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a8e0bb"]])

export default __exports__